<!-- CLIENT APPS -->
<mat-spinner *ngIf="isLoading()"></mat-spinner>
<div *ngIf="!isLoading()">
    <div class="row row-sm">
        <h3>Client Apps</h3>
        <div class="col-xl-6" *ngFor="let app of getCurrentClientApps()">

            <div class="card custom-card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="d-flex">
                                <div class="settings-main-icon me-4 mt-1">
                                    <div class="avatar avatar-md bg-primary-transparent text-primary">
                                        <i *ngIf="app.app == 'accommodation'" class="ti-home fs-18"></i>
                                        <i *ngIf="app.app == 'transport'" class="fa fa-automobile"></i>
                                        <i *ngIf="app.app == 'healthInsurance'" class="fa fa-suitcase-medical"></i>
                                        <i *ngIf="app.app == 'studentVisa'" class="fa fa-graduation-cap"></i>
                                        <i *ngIf="app.app == 'myproject'" class="fa fa-user"></i>
                                    </div>
                                </div>
                                <div>
                                    <h5 class="tx-14 d-flex text-dark tx-uppercase">{{app.name}}</h5>
                                    <p class="tx-13 text-muted mb-0">{{app.description}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer rounded-0">
                    <!-- <a href="javascript:void(0)" class="tx-14 mb-0">Go to Settings</a> -->
                    <label class="custom-switch float-end mb-0">
                        <mat-slide-toggle [checked]="toBool(app.active)" (change)="onActiveSlide(app)">Active</mat-slide-toggle>
                    </label>
                    <label class="custom-switch float-end mb-0">
                        <mat-slide-toggle [checked]="toBool(app.visible)" (change)="onVisibleSlide(app)">Visible</mat-slide-toggle>
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="service-list">
    <!-- Card 1 -->
    <div class="service-card">
      <div class="service-info">
        <div class="service-icon">
          <i class="fas fa-graduation-cap"></i>
        </div>
        <div class="service-details">
          <h4 class="service-name">VISADO</h4>
          <p class="service-description">
            Asistencia para obtener el visado de estudiantes. Requisitos, plazos,
            enlaces para citas, etc.
          </p>
        </div>
      </div>
      <div class="service-status">
        <div class="toggles">
          <label class="switch">
            <input type="checkbox" checked>
            <span class="slider round"></span>
          </label>
          <span><i class="fas fa-eye"></i> Visible</span>
        </div>
        <div class="toggles">
          <label class="switch">
            <input type="checkbox">
            <span class="slider round"></span>
          </label>
          <span><i class="fas fa-check-circle"></i> Active</span>
        </div>
      </div>
      <div class="service-meta">
        <p><i class="fas fa-calendar-check"></i> <strong>Activated At:</strong> 2023-01-01</p>
        <p><i class="fas fa-dollar-sign"></i> <strong>Price:</strong> $4.99</p>
        <p><i class="fas fa-calendar-alt"></i> <strong>Due Date:</strong> 2023-12-31</p>
      </div>
      <div class="service-fields">
        <p><i class="fas fa-th-large"></i> <strong>App:</strong> Visa App</p>
        <p><i class="fas fa-cogs"></i> <strong>Component:</strong> visaComponent</p>
        <p><i class="fas fa-icons"></i> <strong>Icon:</strong> fas fa-graduation-cap</p>
        <p><i class="fas fa-image"></i> <strong>Image URL:</strong> /path/to/image.jpg</p>
        <p><i class="fas fa-link"></i> <strong>URL:</strong> /visa-info</p>
        <p><i class="fas fa-toggle-off"></i> <strong>Disabled:</strong> No</p>
      </div>
    </div>
  </div>
  
  
<!-- CLIENT UTILITIES -->
<div class="product-list">
    <!-- Card 1 -->
    <div class="product-card">
      <div class="product-details">
        <h4 class="category">Extranjería</h4>
        <h5 class="title">Guía de empadronamiento</h5>
        <div class="price">$4.99</div>
        <p class="type">Type: <span>Checklist</span></p>
        <div class="status-badge paid">Paid</div>
        <p class="code">Code: <span>empadronamiento</span></p>
      </div>
      <div class="toggle-section">
        <label class="switch">
          <input type="checkbox" checked>
          <span class="slider round"></span>
        </label>
        <span class="toggle-label">Active</span>
      </div>
    </div>
  
    <!-- Card 2 -->
    <div class="product-card">
      <div class="product-details">
        <h4 class="category">Extranjería</h4>
        <h5 class="title">Permiso de residencia por búsqueda de empleo</h5>
        <div class="price">$5.99</div>
        <p class="type">Type: <span>Unpaid</span></p>
        <div class="status-badge unpaid">Unpaid</div>
        <p class="code">Code: <span>residenciaBusquedaEmpleo</span></p>
      </div>
      <div class="toggle-section">
        <label class="switch">
          <input type="checkbox">
          <span class="slider round"></span>
        </label>
        <span class="toggle-label">Active</span>
      </div>
    </div>
  </div>
  
<mat-spinner *ngIf="isLoading()"></mat-spinner>
<div>
    <div>
        <h3 *ngIf="getClientUtilities().length>0">Client Utilities</h3>
        <div class="col-xl-6" *ngFor="let service of getClientUtilities()">
            <div class="card custom-card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="d-flex">
                                <div class="settings-main-icon me-4 mt-1">
                                    <div class="avatar avatar-md bg-primary-transparent text-primary">
                                        <i *ngIf="service.category == 'Extranjería'" class="ti-home fs-18"></i>
                                        <i *ngIf="service.category == 'health-insurance'" class="fa fa-automobile"></i>
                                        <i *ngIf="service.apcategoryp == 'studentVisa'" class="fa fa-graduation-cap"></i>
                                    </div>
                                </div>
                                <div>
                                    <h5 class="tx-14 d-flex text-dark tx-uppercase">{{service.category}}</h5>
                                    <p class="tx-13 text-muted mb-0">{{service.description}}</p>
                                    <h2 class="d-flex text-dark">${{service.price}}</h2>
                                    <p class="tx-13 text-muted mb-0">Type: {{service.type}}</p>
                                    
                                    <mat-chip-list class="chip-edit" >
                                        <mat-chip class="chip-edit" color="accent" *ngIf="service.paid=='1'"> 
                                            Paid
                                        </mat-chip>
                                        <mat-chip class="chip-edit" color="warn"  *ngIf="service.paid!='1'"> 
                                            Unpaid
                                        </mat-chip>
                                    </mat-chip-list>
                                    <p class="tx-13 text-muted mb-0">Code: {{service.code}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer rounded-0">
                    <!-- <a href="javascript:void(0)" class="tx-14 mb-0">Go to Settings</a> -->
                    <label class="custom-switch float-end mb-0">
                        <mat-slide-toggle [checked]="toBool(service.active)" (change)="onSlideToggleEvent($event,'active',service.id)">Active</mat-slide-toggle>
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>


